// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"046b8432","216":"0fb1a073","261":"1558212a","550":"73916e3c","682":"8459c722","787":"37def5e8","788":"4594bc75","819":"aa664a73"}[chunkId] + ".chunk.js";
};